import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface CanCreateOrganizationStoreState {
  canCreateOrganization: boolean;
  setCanCreateOrganization: (
    canCreateOrganization: boolean | ((canCreateOrganization: boolean) => boolean),
  ) => void;
}

export const useCanCreateOrganizationStore = create(
  devtools<CanCreateOrganizationStoreState>((set) => ({
    canCreateOrganization: true,
    setCanCreateOrganization: (canCreateOrganization) =>
      set((state) => {
        if (typeof canCreateOrganization === 'function') {
          return {
            canCreateOrganization: canCreateOrganization(state.canCreateOrganization),
          };
        }
        return {
          canCreateOrganization,
        };
      }),
  })),
);
